<template>
  <div id="HomeHero">
    <div class="HomeHero">
      <div class="rightSection">
        <img :src="image" alt="" />
      </div>
      <div class="leftSection">
        <div class="LeftInner">
          <h1>{{ Header }}</h1>
          <div class="buttonsSection">
            <div @click="scrollTo('subscribe')">
              <router-link to="/order"
                ><button class="subscribe-button">Subscribe</button></router-link
              >
              
            </div>
            <div @click="scrollTo('orderOnDemand')">
              <router-link to="/order"
                ><button class="order-button">
                  Order On-Demand
                </button></router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Header:
        "Fresh healthy sourced organic milk. Delivered to your doorstep every day.",
      image: require("../assets/Home/hero.png"),
    };
  },
  methods: {
    scrollTo(id) {
      const element = document.getElementById(id);
      element.scrollIntoView({ behavior: "smooth" });
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
};
</script>

<style scoped>
#HomeHero {
  margin-top: 100px;
}
#info {
  width: 100%;
  color: #00ca1b;
  text-align: center;
  font-size: 20px;
  font-weight: none;
}
.HomeHero {
  width: 90%;
  display: flex;
  margin: auto;
  padding-bottom: 50px;
  flex-direction: row-reverse;
}
img {
  /* width: 100%; */
  height: 400.11px;
}

.HomeHero .leftSection,
.HomeHero .rightSection {
  width: 100%;
}
.leftSection {
  display: grid;
  place-items: center;
}
.leftSection .LeftInner {
  width: 95%;
}
h1 {
  color: #343540;
  font-size: 36px;
  font-weight: 700;
  line-height: 60px;
}
button {
  box-sizing: border-box;
  height: 60px;
  width: 220px;
  border-radius: 60px;
  border: unset;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
  background-color: transparent;
}
.subscribe-button {
  border: 2px solid #0077b6;
  color: #0077b6;
  margin-right: 30px;
}
.order-button {
  background-color: #06d6a0;
  color: #fff;
}
.buttonsSection {
  display: flex;
  /* flex-wrap: wrap; */
}
@media screen and (max-width: 720px) {
  .HomeHero {
    display: block;
  }
  img {
    width: 100%;
    height: unset;
  }
  h1 {
    font-size: 30px;
    font-weight: 700;
    text-align: center;
  }
  .subscribe-button {
    margin: unset;
  }
  button {
    margin: 20px;
  }
  .leftSection .LeftInner {
    width: 90%;
  }
  .buttonsSection {
    display: grid;
    place-items: center;
  }
  .leftSection div p {
    text-align: center;
    font-size: 17px;
    line-height: 20px;
  }
}
</style>